import { createFileRoute } from "@tanstack/react-router";

import { ContractsPending } from "../contracts/pending.tsx";
import { CostsPage } from "../costs/costs-page.tsx";
import { loadCosts } from "../costs/loaders.ts";
import { useViewer } from "../data/hooks.ts";
import { costsSearch } from "../shell/costs-search.ts";
import { isSectionShown, sections } from "../shell/navigation.ts";
import { retainPropertyFilter } from "../shell/search.ts";
import { NotFoundPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

// WHY: money is confidential: below manager the route answers not found (28-running-costs → States), never "no access".
const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null || !isSectionShown(sections.costs, viewer.role) ? (
    <NotFoundPage />
  ) : (
    <CostsPage viewer={viewer} />
  );
};

export const Route = createFileRoute("/_app/costs/")({
  staticData: { hasPropertyContext: true },
  validateSearch: costsSearch,
  search: retainPropertyFilter(),
  loader: async ({ context }) => loadCosts(context.data),
  pendingComponent: ContractsPending,
  component: Page,
});
